import { t } from 'i18next'

import HeaderPages from '~/components/HeaderPages'
import PageTitle from '~/components/PageTitle'
import { isReadOnly } from '~/helpers'

import AdSizeForm from './components/Form'
import { AdSizeProvider } from './components/Form/hook/useAdSizeForm'
import AdSizeTable from './components/Table'

const AdSizes: React.FC = () => (
  <>
    <PageTitle title={t('rm:adsize.page.title')} />

    <HeaderPages
      title={t('rm:adsize.page.title')}
      subtitle={t('rm:adsize.page.subtitle')}
    />

    <section className="container">
      <AdSizeProvider>
        <div className="row">
          <AdSizeTable />

          {!isReadOnly() && <AdSizeForm />}
        </div>
      </AdSizeProvider>
    </section>
  </>
)

export default AdSizes